<template>
  <div class="flex flex-col items-center justify-center gap-4 pt-6">
    <!-- Items counter -->
    <div class="text-sm text-gray-600" aria-live="polite">
      <template v-if="totalItems > 0">
        {{ $t('common.pagination.showingItem', {
          index: absoluteIndex,
          total: totalItems,
          records: $t('common.pagination.records', totalItems)
        }) }}
      </template>
      <template v-else>
        {{ $t('common.pagination.showingItemOnPage', {
          index: currentItemIndex + 1,
          perPage: itemsPerPage,
          page: modelValue,
          pages: totalPages
        }) }}
      </template>
    </div>

    <!-- Navigation buttons -->
    <div class="flex items-center justify-center gap-4">
      <button
        @click="goToPreviousItem"
        :disabled="props.currentItemIndex === 0 && modelValue === 1"
        class="px-4 h-10 flex items-center justify-center rounded-full border border-[#2AB4D9] bg-[#2AB4D9] text-white text-sm whitespace-nowrap cursor-pointer hover:bg-[#2ab3d9d4] disabled:opacity-50 disabled:cursor-not-allowed duration-300"
      >
        {{ $t('common.pagination.previous') }}
      </button>

      <button
        @click="goToNextItem"
        :disabled="props.currentItemIndex === itemsPerPage - 1 && modelValue === totalPages"
        class="px-4 h-10 flex items-center justify-center rounded-full border border-[#2AB4D9] bg-[#2AB4D9] text-white text-sm whitespace-nowrap cursor-pointer hover:bg-[#2ab3d9d4] disabled:opacity-50 disabled:cursor-not-allowed duration-300"
      >
        {{ $t('common.pagination.next') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  totalPages: {
    type: Number,
    required: true
  },
  modelValue: {
    type: Number,
    required: true
  },
  totalItems: {
    type: Number,
    required: true
  },
  itemsPerPage: {
    type: Number,
    default: 10
  },
  currentItemIndex: {
    type: Number,
    required: true
  }
});

const emit = defineEmits(['update:modelValue', 'update:currentItemIndex']);

// Posición del elemento dentro del total (no dentro de la página).
const absoluteIndex = computed(() =>
  Math.min((props.modelValue - 1) * props.itemsPerPage + props.currentItemIndex + 1, props.totalItems)
);

const goToPreviousItem = () => {
  if (props.currentItemIndex > 0) {
    // Si no estamos en el primer item de la página actual
    emit('update:currentItemIndex', props.currentItemIndex - 1);
  } else if (props.modelValue > 1) {
    // Si estamos en el primer item y no estamos en la primera página
    emit('update:modelValue', props.modelValue - 1);
  }
};

const goToNextItem = () => {
  if (props.currentItemIndex < props.itemsPerPage - 1) {
    // Si no estamos en el último item de la página actual
    emit('update:currentItemIndex', props.currentItemIndex + 1);
  } else if (props.modelValue < props.totalPages) {
    // Si estamos en el último item y no estamos en la última página
    emit('update:modelValue', props.modelValue + 1);
  }
};
</script>
